import { render } from "./VideoGeneralComponent.vue?vue&type=template&id=d9fe9d00"
import script from "./VideoGeneralComponent.vue?vue&type=script&lang=js"
export * from "./VideoGeneralComponent.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__